import { render } from "./Project-card.vue?vue&type=template&id=91f118f0&scoped=true"
import script from "./Project-card.vue?vue&type=script&lang=js"
export * from "./Project-card.vue?vue&type=script&lang=js"

import "./Project-card.vue?vue&type=style&index=0&id=91f118f0&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f118f0"]])

export default __exports__